import { PartList } from "./music-objects";

// This class is a helper for caching. It is a map that utilizes a histogram to keep track of the frequency that each key is accessed. When the limit is reached, the least frequent key is removed.
class HistoMap<K, V> {
private map: Map<K, V> = new Map();
	private histo: Map<K, number> = new Map();
	private limit: number;

	constructor(limit: number) {
		this.limit = limit;
	}

	get(key: K): V | undefined {
		const value = this.map.get(key);
		if (value !== undefined) {
			const count = this.histo.get(key) || 0;
			this.histo.set(key, count + 1);
		}
		return value;
	}

	set(key: K, value: V) {
		if (this.map.size >= this.limit) {
			let minKey: K | undefined;
			let minCount = Number.MAX_SAFE_INTEGER;
			for (const [key, count] of this.histo.entries()) {
				if (count < minCount) {
					minKey = key;
					minCount = count;
				}
			}
			if (minKey !== undefined) {
				this.map.delete(minKey);
			}
		}
		this.map.set(key, value);
		if (!this.histo.has(key)) {
			this.histo.set(key, 0);
		}
	}

	delete(key: K) {
		this.map.delete(key);
		this.histo.delete(key);
	}

	clear() {
		this.map.clear();
		this.histo.clear();
	}

	resetHistogram() {
		this.histo.forEach((_, key) => {
			this.histo.set(key, 0);
		});
	}
}

export const MidiBlockCache = new HistoMap<string, JSX.Element>(500);
export const SongPartListCache = new HistoMap<string, PartList>(20);